import React, { useEffect, useState } from "react";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";
import { whoIsAthleteCoach } from "../../../../utils/user-helpers";
import ConfirmationModal from "../../../../parts/modals/ConfirmationModal";

const UploadGuide = (props) => {
  const {
    name,
    athlete,
    field,
    setcansubmit,
    inputRef,
    coachOrganizationInformation,
    activeUser,
  } = props;
  const guide = athlete.guides?.[field];
  const [athleteId, setAthleteId] = useState("");
  const initialState = {
    src: guide?.s3Path || undefined,
    backgroundedit:
      guide && Object.keys(guide).length > 0
        ? "/img/widget-icons/pdf-alt.svg"
        : undefined,
    nameFile: guide?.displayName || undefined,
  };
  const [state, setState] = useState(initialState);
  const [openedConfirmationModal, setOpenedConfirmationModal] = useState(false);
  const { src, backgroundedit, nameFile } = state;
  const type = name === "meal-file" ? "meal" : "supplement";

  const handleChange = ({ target }) => {
    if (!target.value) {
      return false;
    } else {
      // extract file
      const file = target.files[0];

      // setup file reader
      const fileReader = new FileReader();

      // store the image in state once it's loaded off the file system
      fileReader.onload = (event) => {
        setState({
          src: URL.createObjectURL(file),
          nameFile: file.name,
          backgroundedit: file.name.includes(".pdf")
            ? "/img/widget-icons/pdf-alt.svg"
            : file.name.includes(".xlsx") || file.name.includes(".docx")
            ? "/img/widget-icons/document-alt.svg"
            : "/img/widget-icons/image-alt.svg",
        });
        setcansubmit(true);
        inputRef.current.disabled = true;
      };

      // handle the error...kind of.
      fileReader.onerror = function (event) {
        console.error(
          "File could not be read! Code " + event.target.error.code
        );
      };

      // finally read the file
      fileReader.readAsDataURL(file);
    }
  };

  const handleCancelDelete = () => {
    setOpenedConfirmationModal(false);
  };

  const handleConfirmDelete = () => {
    let body = {
      athleteId: athlete._id,
      type: type,
    };
    if (coachOrganizationInformation) {
      const userToRequest =
        String(
          whoIsAthleteCoach(
            activeUser.athletes,
            athlete._id,
            activeUser._id,
            coachOrganizationInformation._id
          )
        ) !== String(activeUser._id)
          ? coachOrganizationInformation._id
          : activeUser._id;

      body = {
        ...body,
        userToRequest,
      };
    }
    submit("/actions/guides/remove", {
      method: "POST",
      body,
    });
    setState({
      src: undefined,
      backgroundedit: undefined,
      nameFile: undefined,
    });
    inputRef.current.disabled = false;
    const inputElement = document.getElementById(name);
    if (inputElement) {
      inputElement.value = "";
    }
    setOpenedConfirmationModal(false);
  };

  const handleReset = (e) => {
    e.preventDefault();
    setState({
      src: undefined,
      backgroundedit: undefined,
      nameFile: undefined,
    });
    inputRef.current.disabled = false;
    const inputElement = document.getElementById(name);
    if (inputElement) {
      inputElement.value = "";
    }
  };
  useEffect(() => {
    if (athlete._id !== athleteId) {
      setAthleteId(athlete._id);
      setState({
        src: guide?.s3Path || undefined,
        backgroundedit:
          guide && Object.keys(guide).length > 0
            ? "/img/widget-icons/pdf-alt.svg"
            : undefined,
        nameFile: guide?.displayName || undefined,
      });
      if (inputRef?.current) {
        if (!guide) {
          inputRef.current.disabled = false;
        } else inputRef.current.disabled = true;
      }
    }
  }, [athlete]);
  const handleRemove = (e) => {
    e.preventDefault();
    setOpenedConfirmationModal(true);
  };
  return (
    <>
      <label>
        {!backgroundedit ? (
          <div className="empty">
            <SvgIcon
              height={20}
              width={20}
              alt=""
              src="/img/new-icons/add.svg"
            />

            <p className="p4">Upload a pdf</p>
          </div>
        ) : (
          <div style={inputRef?.current ? { cursor: "auto" } : {}}>
            <SvgIcon
              height={24}
              width={24}
              alt=""
              src="/img/new-icons/vuesax-linear-tick-circle-gradient.svg"
              noFilterOnLight={true}
            />

            <p>{nameFile}</p>

            <footer>
              <a
                role="button"
                data-button-type="primary"
                href={src}
                target="_blank"
              >
                Preview
              </a>
              <div>
                <button data-button-type="secondary" onClick={handleReset}>
                  Change
                </button>
                <button data-button-type="secondary" onClick={handleRemove}>
                  Remove
                </button>
              </div>
            </footer>
          </div>
        )}
        <input
          style={{ display: "none" }}
          id={name}
          className="file-input"
          type="file"
          accept=".pdf"
          {...props}
          onChange={handleChange}
          defaultValue={undefined}
          ref={inputRef}
        />
      </label>
      <ConfirmationModal
        isOpen={openedConfirmationModal}
        title={`Delete ${type} guide?`}
        contentText={`Are you sure you want to delete this ${type} guide? \n If you delete it, you won’t be able to recover the ${type} guide back.`}
        cancelButtonText="Cancel"
        cancelButtonAction={handleCancelDelete}
        confirmButtonText="Delete"
        confirmButtonAction={handleConfirmDelete}
      />
    </>
  );
};

export default UploadGuide;
